// Variables a user can insert into an ad-name field via AdNameField.vue.
// The backend resolves these tokens to plain values when saving the ad —
// the frontend only validates that no unknown tokens slip through.

export const AD_NAME_VARIABLES = [
  'campaign.id',
  'campaign.name',
  'adgroup.id',
  'adgroup.name',
  'format',
  'ad_type',
]

const VALID_KEYS = AD_NAME_VARIABLES.reduce((acc, key) => {
  acc[key] = true
  return acc
}, {})

const TOKEN_RE = /\{\{\s*([a-zA-Z._]+)\s*\}\}/g

export function findUnknownTokens(adName) {
  if (!adName) return []
  const unknown = []
  TOKEN_RE.lastIndex = 0
  let match = TOKEN_RE.exec(adName)
  while (match !== null) {
    const key = match[1].trim()
    if (!VALID_KEYS[key] && unknown.indexOf(key) === -1) unknown.push(key)
    match = TOKEN_RE.exec(adName)
  }
  return unknown
}
